<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
   sodipodi:docname="tongue_N_square_4.svg"
   id="svg1118"
   version="1.1"
   viewBox="0 0 360 400"
   :height="height"
   :width="width">
  <defs
     id="defs1112">
      <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     inkscape:window-maximized="0"
     inkscape:window-y="23"
     inkscape:window-x="0"
     inkscape:window-height="755"
     inkscape:window-width="1252"
     scale-x="1"
     units="px"
     showgrid="false"
     inkscape:document-rotation="0"
     inkscape:current-layer="layer2"
     inkscape:document-units="px"
     inkscape:cy="143.32323"
     inkscape:cx="1.4435368"
     inkscape:zoom="0.98994949"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     borderopacity="1.0"
     bordercolor="#666666"
     pagecolor="#ffffff"
     id="base" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
   <path
       id="outside"
       style="opacity:0.299035;fill:#ff000000;stroke:#ffffff;stroke-width:0.5;stroke-miterlimit:4;stroke-dasharray:none"
       d="M 0 0 L 0 400 L 360 400 L 360 0 L 0 0 z M 233.5293 23.509766 C 246.97752 23.3046 260.25482 31.598683 276.61914 63.585938 C 295.52452 102.37413 293.61364 155.83369 292.4668 200.79688 C 291.31996 245.76007 283.72531 308.1525 266.21875 340.61523 C 248.7122 373.07798 218.6878 373.93164 179.50977 373.93164 C 140.33169 373.93164 110.39851 373.69563 93.029297 341.08398 C 75.660048 308.47231 70.565082 242.35551 67.285156 200.00391 C 64.00523 157.65231 66.810937 110.12455 83.566406 63.037109 C 117.54265 -4.0037636 143.9646 34.75055 182.40625 34.84375 C 202.82838 34.893263 218.28798 23.742286 233.5293 23.509766 z " />
   <path
       inkscape:connector-curvature="0"
       d="M 180,8.7871098 A 112.69226,31.88006 0 0 0 67.308594,40.667969 112.69226,31.88006 0 0 0 86.068359,58.279297 C 118.85336,-2.0964097 144.91382,34.75285 182.40625,34.84375 219.8131,34.93444 240.5749,-2.5353767 273.83203,58.322266 A 112.69226,31.88006 0 0 0 292.69141,40.667969 112.69226,31.88006 0 0 0 180,8.7871098 Z"
       style="display:inline;fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       id="mouth" />
  <g id="cover_layer">
     <path
       id="cover"
       style="fill:none;stroke:#ff000000;stroke-width:1.90784px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 228.17028,23.395621 C 214.55273,23.603369 200.74015,33.566353 182.49373,33.522115 148.14755,33.438844 124.54052,-1.1866959 94.184009,58.711834 79.21362,100.78271 76.706825,143.24702 79.637317,181.0866 c 2.930493,37.83958 7.482655,96.91249 23.001433,126.0498 15.51874,29.1373 42.26293,29.34817 77.26709,29.34817 35.00411,0 61.8298,-0.76272 77.47125,-29.76698 15.64146,-29.00424 22.427,-84.74956 23.45166,-124.9225 1.02466,-40.17294 2.73196,-87.937084 -14.1593,-122.592897 -14.62091,-28.579425 -26.48368,-35.98988 -38.49917,-35.806572 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="ssczssszcs" />
  </g>
  <g
     inkscape:groupmode="layer"
     id="body_layer"
     inkscape:label="Layer 2">
    <path
       sodipodi:nodetypes="ssczssszcs"
       inkscape:connector-curvature="0"
       d="m 233.5293,23.509761 c -15.24132,0.23252 -30.70092,11.383497 -51.12305,11.333984 -38.44165,-0.0932 -64.8636,-38.847514 -98.839844,28.193359 -16.755469,47.087436 -19.561175,94.615206 -16.281249,136.966806 3.279926,42.3516 8.374891,108.4684 25.74414,141.08007 17.369213,32.61165 47.302393,32.84766 86.480473,32.84766 39.17803,0 69.20243,-0.85366 86.70898,-33.31641 17.50656,-32.46273 25.10121,-94.85516 26.24805,-139.81835 1.14684,-44.96319 3.05772,-98.42275 -15.84766,-137.210947 C 260.25482,31.598678 246.97752,23.304595 233.5293,23.509761 Z"
       style="fill:#f59a9a;stroke:#ff000000;stroke-width:2.13533px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       id="body" />
    <path
       id="k-bl-li"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.5;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 233.5293,23.509766 C 218.28798,23.742286 202.82838,34.893263 182.40625,34.84375 143.9646,34.75055 117.54265,-4.0037636 83.566406,63.037109 80.51316,71.617565 77.937756,80.250537 75.777344,88.880859 157.66185,103.41817 223.54301,98.40407 285.42578,88.503906 283.27766,79.767393 280.43065,71.406014 276.61914,63.585938 260.25482,31.598683 246.97752,23.3046 233.5293,23.509766 Z"
       inkscape:connector-curvature="0" />
    <path
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.766728;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 75.693359,89.212891 c -9.619605,38.619899 -10.846221,77.178499 -8.408203,110.791019 1.181147,14.38638 2.509252,31.1344 4.371094,48.27734 2.706002,22.23785 6.370565,44.29423 11.171875,65.30469 7.333069,-5.15601 22.772865,-11.37874 30.050785,-14.41406 -10.19898,-68.50782 -13.3407,-133.5871 -1.47266,-204.794927 z"
       inkscape:connector-curvature="0" />
    <path
       sodipodi:nodetypes="ccccc"
       inkscape:connector-curvature="0"
       d="m 82.828243,313.58651 c 4.306509,13.94415 5.657577,21.25689 12.938874,32.33475 30.310143,-9.91068 138.889193,-12.49734 168.008043,-0.62089 6.80236,-13.41352 9.77074,-21.37406 13.9668,-36.33591 -61.47443,-32.71426 -143.11372,-27.30348 -194.913717,4.62205 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.766728;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="lg" />
    <path
       sodipodi:nodetypes="ccccc"
       inkscape:connector-curvature="0"
       d="M 112.87951,299.17199 C 102.68053,230.66425 99.539141,165.58335 111.40718,94.375537 c 50.24569,5.480919 94.49373,4.11048 136.04186,-0.341344 13.848,75.134487 9.91712,137.570347 -1.01832,201.924447 -57.5837,-16.55392 -104.11459,-6.79415 -133.55121,3.21335 z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.766728;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="st-sp" />
    <path
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.5;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 285.42578,88.503906 c -12.65727,1.95954 -25.01331,3.744294 -37.97674,5.530287 13.85413,75.147007 9.91943,137.562777 -1.0174,201.924787 0,0 18.9426,5.93104 31.30859,13.00391 0.012,-0.0468 0.0232,-0.0938 0.0352,-0.14062 5.1032,-21.02599 9.31733,-50.25545 12.31445,-81.2168 0.005,-0.0484 0.0111,-0.0982 0.0156,-0.14649 0.004,-0.0428 0.008,-0.0861 0.0117,-0.1289 0.0362,-0.37485 0.0696,-0.75357 0.10547,-1.12891 0.32427,-3.47987 0.62466,-6.83723 0.91992,-10.18555 0.47072,-5.47583 0.90308,-10.97477 1.29492,-16.47265 -1.06609,-36.54779 1.21454,-76.96852 -7.01172,-111.039064 z"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="cccccccscccc" />
    <path
       sodipodi:nodetypes="cscc"
       inkscape:connector-curvature="0"
       d="m 96.548611,345.30037 c 17.654079,27.98256 46.485219,28.21609 83.663219,28.21609 36.9637,0 65.75816,-0.77713 83.56333,-28.21609 -24.17806,-11.40679 -124.18011,-9.92951 -167.226549,0 z"
       style="fill:none;stroke:#00000f;stroke-width:0.76544;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="he" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>